const ROUTE_PATHS = {
  preload: '/onboarding/:token',
  authentication: '/onboarding/auth/:token',
  profile: '/onboarding/profile/:token',
  identityValidation: '/onboarding/identity-validation/:token',
  authorize: '/onboarding/authorize/:token',
  success: '/onboarding/success/:token',
  error: '/onboarding/invalid/request',
};

export default ROUTE_PATHS;
